export interface User {
  company?: string;
  departmentEn?: string;
  departmentJp?: string;
  employeeId: string;
  id: number;
  nameEn?: string;
  nameJp: string;
}

/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const getUserByAPIResponse = (user: any): User => ({
  company: user.company,
  departmentEn: user.department_en,
  departmentJp: user.department_jp,
  employeeId: user.employee_id,
  id: user.id,
  nameEn: user.name_en,
  nameJp: user.name_jp,
});
/* eslint-enable */
